import {PortfolioPaper} from '../../../../_shared/model';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import 'rxjs';
import {HttpClientService} from '../../../../_shared/services/http-client.service';
import {HelperService} from '../../../../_shared/services';

@Injectable({
    providedIn: 'root',
})
export class ResultService {
    constructor(private httpClient: HttpClientService, private helper: HelperService) {}

    //getVisitPortfolio
    public getVisitPortfolio(contractorId: number, visitId: number): Observable<PortfolioPaper[]> {
        return this.httpClient.get(
            this.helper.getVisitUrl() + `/contractors/${contractorId}/visits/${visitId}/portfolio`,
        );
    }
}
